import styled from "@emotion/styled";
import { useEffect, useState } from 'react';
import { i18n, mediaQuery, navigate, openCallMeModal, useGeneralSoContext, useGetSo, useSetPaymentErrors, useIframeDetection } from 'src/common';
import { useGetOffer } from 'src/common/apiGraphql/queries/useGetOffer.query';
import { Button, Flex, Loader, StatusMessage } from 'src/components';
import { footer, header } from 'src/theme';
import { AppRoutes } from "./_router/app.routes";

const ButtonContainerStyle = styled.div({
  marginTop: 32
})

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

/**
 * Alternative implementation using the useIframeDetection hook
 * This is a cleaner approach for iframe detection
 */
const CheckoutFailurePageWithHook = () => {
  const { so, refetch } = useGetSo();
  const { offerId, soId } = useGeneralSoContext();
  const { offer, refetch: refetchOffer } = useGetOffer();
  const [setPaymentErrors] = useSetPaymentErrors();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [errors, setErrors] = useState<string | null>(null);

  // Use the custom hook for iframe detection
  const { iframeInfo, isLoading: iframeLoading, sendToParent, isInIframe } = useIframeDetection();

  useEffect(() => {
    if (!soId || !offerId) {
      navigate(AppRoutes.WEBSHOP.STEP_1);
      return;
    }
    if (so) {
      refetch();
    }
    if (offer) {
      refetchOffer();
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setErrors(queryParams.get('ErrorCodes'));
  }, []);

  useEffect(() => {
    if (errors && !isSubmitted) {
      setIsSubmitted(true);
      setPaymentErrors({
        paymentErrors: errors.split(',')
      });
    }
  }, [errors, offerId]);

  // Handle iframe communication when errors are available
  useEffect(() => {
    if (errors && isInIframe && !iframeLoading) {
      sendToParent({
        type: 'CHECKOUT_FAILURE',
        data: {
          errors: errors
        }
      });
    }
  }, [errors, isInIframe, iframeLoading, iframeInfo, offerId, soId, sendToParent]);


  const Buttons = () => (
    <ButtonContainerStyle>
      <Flex vertical gap={32} align='center'>
        <div>
          <Button btnType='primary' onClick={() => navigate(`${AppRoutes.WEBSHOP.CHECKOUT}`)}>
            {i18n.t('pages.checkoutFailurePage.tryAgainButton')}
          </Button>
        </div>
        <div>
          <Button btnType='textBlack' onClick={() => openCallMeModal()}>
            {i18n.t('pages.checkoutFailurePage.requestCallButton')}
          </Button>
        </div>
      </Flex>
    </ButtonContainerStyle>
  );

  return (
    <>
      {iframeInfo?.isInIframe && <Loader />}
      {!iframeInfo?.isInIframe && <FlexStyle justify='center' align='center'>
        <StatusMessage buttons={<Buttons />} title={i18n.t('pages.checkoutFailurePage.title')} subtitle={i18n.t('pages.checkoutFailurePage.subtitle')} />
      </FlexStyle>}
    </>
  );
}

export default CheckoutFailurePageWithHook;
